import script from "./TableInvoiceProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./TableInvoiceProxy.vue?vue&type=script&setup=true&lang=js"

import "./TableInvoiceProxy.vue?vue&type=style&index=0&id=1b1f2996&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1f2996"]])

export default __exports__